import CiviliteSelect from '@/generated/controls/civilite/CiviliteSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: CiviliteSelect
})
